// const API_URL = 'http://localhost:8000/api';
const API_URL = 'https://ebmt2022presenter.planner.documedias.systems/api/';

const FILE_SERVER_URL = 'https://fileserver.documedias.com/';

//CTIWP ACCOUNT
const VUE_APP_VIMEO_FOLDER_ID = 7814275;
const VUE_APP_VIMEO_EMBED_PRESET_ID = "";
//const VUE_APP_VIMEO_APP_SECRET = "L72ftTwmhMRlDZczaQo4wQiftcZRtips3iqDcGAxvIC1Si7pP4HcgImEjmaZ4TS0y9R9pXiYKfyLAVkouJ2w4xj6c8Miw75OZb6ZcUsrWtbxlsvPVT4KrynD6TENxGnn";
//const VUE_APP_VIMEO_ID = "3254a4a0eba2e503e13cc7454a9f457738ee7d7b";
//const VUE_APP_VIMEO_ACCESS_TOKEN = "e40c7beed1717f624d553ed0c0a790c5";

//DOCU ACCOUNT
//const VUE_APP_VIMEO_FOLDER_ID=3330658
const VUE_APP_VIMEO_APP_SECRET="fLDdfW0Zcbr861hpiujjIMT1eV9SjO6Yr8vNMaNPTu2thN36Wmj2n2HLQn0JLqYtCL22tWeYPVsHPkxG2fhAoLBgq8LHhmVbRymKK4tMbZlac82KoI2YpBn0SSgPIVtR"
const VUE_APP_VIMEO_ID="a132dc7524225aa95b2d7ee342db0c0a25ed539c"
const VUE_APP_VIMEO_ACCESS_TOKEN="8a74980b2db885d666182f045e810a3c"


const VUE_APP_UPLOAD_PREFIX = "ebmt2022_";

export {
    API_URL,
    FILE_SERVER_URL,
    VUE_APP_VIMEO_FOLDER_ID,
    VUE_APP_UPLOAD_PREFIX,
    VUE_APP_VIMEO_ACCESS_TOKEN,
    VUE_APP_VIMEO_APP_SECRET,
    VUE_APP_VIMEO_EMBED_PRESET_ID,
    VUE_APP_VIMEO_ID
}
